<template>
  <article
    v-if="job"
    class="relative max-w-sm bg-transparent rounded-xl dark:bg-gray-800 dark:border-gray-700 mt-16"
  >
    <header
      class="w-full flex justify-center absolute -top-16"
      :data-job-id="job?.JobId"
    >
      <img
        class="size-32 mb-3 rounded-full"
        :src="
          job?.BannerUrl?.length
            ? job?.BannerUrl
            : 'https://picsum.photos/id/1/240/240'
        "
        alt=""
      />
    </header>
    <section
      class="p-5 pt-20 bg-cardBg rounded-t-xl"
      :style="{ minHeight: `calc(100% - ${footerHeight})` }"
    >
      <h3
        class="truncate mb-2 text-2xl tracking-tight text-textMain text-center"
      >
        {{ job?.JobTitle }}
      </h3>
      <ClientOnly>
        <div class="line-clamp-4 mb-3 font-normal text-gray-700 min-h-24">
          {{ job?.Description?.trim() }}
        </div>
      </ClientOnly>
    </section>
    <footer
      ref="footerRef"
      class="bg-cardBg pb-6 flex justify-center rounded-b-xl"
    >
      <BaseNuxtLinkButton
        :to="job?.JobUrl?.slice(job?.JobUrl?.indexOf('/vacancy'))"
      >
        {{ LANG.moreDetailsAndApplication[lang] }}
      </BaseNuxtLinkButton>
    </footer>
  </article>
</template>

<script setup lang="ts">
import { LANG } from '@/config/lang';
import { IJobsItemInfo } from '@/types/jobs';
import { LangType } from '@/types/lang';

withDefaults(defineProps<{ lang?: LangType; job: IJobsItemInfo }>(), {
  lang: 'he',
});
const emits = defineEmits<{ apply: [] }>();

const footerRef = ref(null);
// @ts-ignore
const footerHeight = computed(() => footerRef.value?.height ?? 0);
</script>

<style scoped></style>
